/**
 * Find and replace state tags within a string.
 * @param {string} string
 * @param {object} state
 * @returns {string}
 */
const parseTags = (string, state) => {
  if (!string.includes('{{ ')) {
    return string;
  }

  const regex = /{{\s*([^}]+)\s*}}/g;

  let parsed = string;
  let match = regex.exec(parsed);

  while (match !== null) {
    const shortcode = match[0];
    const key = match[1].trim();

    if (key in state) {
      parsed = parsed.replace(shortcode, state[key]);
    }

    match = regex.exec(parsed);
  }

  return parsed;
};

/**
 * Converts a string to a camelcase key.
 * @param {string} key
 * @returns {string}
 */
const normaliseKey = (key) =>
  key
    .toLowerCase()
    .replace(/[^a-z ]/g, '')
    .replace(/\s\w/g, (v) => v.toUpperCase().trim());

export { parseTags, normaliseKey };
